<template>
    <div>        
        <list :label="$t('user')" v-bind:refresh="this.refresh" table='logins' v-on:childMessage="onMessageFromListReceived" initialSortBy="login" :initialSortDesc="false"></list>
        <v-dialog v-bind:value="showDialog" v-bind:persistent="true" max-width="600">
            <v-card>
                <v-card-title>
                    {{title}}
                </v-card-title>
                <v-card-text>
                    <div v-for="field in fields" v-bind:key="field.value">
                        <div v-if="field.value !== 'id' && field.value !== 'actions'">
                            <v-switch v-if="field.value == 'isadmin'" v-model="field.model" v-bind:label="field.text"></v-switch>
                            <v-text-field v-else-if="field.value != 'customername'" v-model="field.model" v-bind:label="field.text"/>
                            <v-select v-else v-model="field.model" v-bind:label="field.text" :items=getCustomers() item-text="customername" item-value="id" :clearable="true"></v-select>
                        </div>
                    </div>
                    <v-chip outlined color="primary" v-if='this.text!=""'>
                        {{text}}
                    </v-chip>
                </v-card-text>
                <v-card-actions>
                    <v-btn elevation="20" class="white--text" color="#49a5ac" @click=save()><v-icon dense left>mdi-content-save-outline</v-icon>{{$t('save')}}</v-btn>
                    <v-btn elevation="20" class="white--text" color="#49a5ac" @click=cancel()><v-icon dense left>mdi-cancel</v-icon>{{$t('cancel')}}</v-btn>
                </v-card-actions>
            </v-card>

        </v-dialog>
    </div>
</template>

<script>

import List from "@/components/List"
import Api from "@/Api"
import { Utils } from "@/Utils"

export default {
    components:
    {
        List
    },

    data()
    {
        return {
            showDialog: "",
            fields: [],
            refresh: 0,
            title: "",
            text: ""
        };
    },

    props: [],

    mixins: [Utils],

    methods:
    {
        onMessageFromListReceived (message)
        {
            this.text = "";
            if (message.cmd === "newRecord")
            {
                this.title = this.$t("new user");
                this.fields = JSON.parse(JSON.stringify(message.header));
                this.fields.shift(); //remove ID

                for (let field of this.fields)
                {
                    field.model = "";
                    if (field.value === "lastlogin")
                    {
                        field.value = "password";
                        field.text = this.$t("password");
                    }
                }
                this.showDialog = true;
            }
            else if (message.cmd === "updRecord")
            {
                this.title = this.$t("update user");
                this.fields = JSON.parse(JSON.stringify(message.header));

                for (let field of this.fields)
                {
                    if (field.value === "lastlogin")
                    {
                        field.value = "password";
                        field.text = this.$t("password");
                        field.model = ""
                    }
                    else if (field.value === "customername")
                    {
                        const customerId = this.getCustomerId(message.item[field.value]);
                        if (customerId > 0)
                            field.model = customerId;
                        else
                            field.model = ""
                    }
                    else
                        field.model = message.item[field.value]
                }
                this.showDialog = true;
            }
            else if (message.cmd === "delRecord")
            {
                let id = message.item["id"];
                const self = this;
                Api.deleteRecord("logins", id).then(function(result)
                {
                    if (result.status === 200)
                    {
                        self.refresh += 1;
                    }
                    else
                        alert (self.$t("action not possible"));

                })
                .catch((e) =>
                {
                    alert (self.$t("action not possible"));
                });
            }
        },
        cancel ()
        {
            this.showDialog = "";
            this.fields = [];
        },
        save ()
        {
            const self = this;
            this.text = "";
            let isAdmin = false;
            let isCustomer = false;

            for (let field of this.fields)
            {
                if (field.value === "login")
                {
                    if (field.model.trim() == "")
                    {
                        this.text = this.$t("enter login")
                        return;
                    }
                }                
                else if (field.value == "isadmin")                
                    isAdmin = field.model;                
                else if (field.value == "customername")
                {
                    if (typeof(field.model) == "undefined")                    
                        field.model = "";
                    
                    isCustomer = field.model != "";
                }
            }

            if (isAdmin && isCustomer)
            {                
                this.text = this.$t("customer no admin");
                return;
            }
            else if (!isAdmin && !isCustomer)
            {                
                this.text = this.$t("select customer");
                return;
            }
            Api.saveRecord("logins", this.fields).then(function(result)
            {
                if (result.status === 200)
                {
                    self.showDialog = "";
                    self.refresh += 1;
                }
                else
                    self.text = self.$t("action not possible");

            })
            .catch((e) =>
            {
                if (e.response.status === 409)
                    self.text = self.$t("already exists");
                else
                    self.text = self.$t("action not possible");
            });
        }
    }
};
</script>